import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import { secretCodeAES } from "./app-constants";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { store } from "../hooks/redux/store";
import { DNA } from "react-loader-spinner";

// Toast emitter
export const toastEmitter = (type = "info", message = "") => {
  const commonOptions = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  switch (type) {
    case "success":
      toast.success(message, commonOptions);
      break;
    case "warn":
      toast.warn(message, commonOptions);
      break;
    case "error":
      toast.error(message, commonOptions);
      break;
    case "info":
      toast.info(message, commonOptions);
      break;
    default:
      toast(message, commonOptions);
  }
};

// Encrypt JSON to AES
export const encryptJSONtoAES = (str) =>
  str ? CryptoJS.AES.encrypt(JSON.stringify(str), secretCodeAES).toString() : false;

// Decrypt AES to JSON (with fallback and consistent return type)
export const decryptAEStoJSON = (str) => {
  if (!str) return false;
  try {
    const decryptedText = CryptoJS.AES.decrypt(str, secretCodeAES).toString(CryptoJS.enc.Utf8);
    return decryptedText ? JSON.parse(decryptedText) : false;
  } catch (error) {
    console.error("Failed to decrypt or parse JSON:", error);
    return false;
  }
};

// Encrypt string to AES
export const encryptStringtoAES = (str) =>
  str ? CryptoJS.AES.encrypt(str.toString(), secretCodeAES).toString() : false;

// Decrypt AES to string
export const decryptAEStoString = (str) =>
  str ? CryptoJS.AES.decrypt(str, secretCodeAES).toString(CryptoJS.enc.Utf8) : "";

// Get currently logged-in user
export const getCurrentUser = () => {
  const state = store.getState();
  const loggedUser = state.loggedUser.value;
  return loggedUser ? decryptAEStoJSON(loggedUser) : false;
};

// Format date to locale string, returns "" if invalid
export const modifyTableDate = (str) =>
  str ? new Date(str).toLocaleString() : "";

// Download file from blob
export const downloadFile = (filetype, response, filename) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${filename}-${new Date().getTime()}.${filetype}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

// Format date to MM-DD-YYYY
const newLocal_1 = (date) => {
  const objectDate = new Date(date);
  const day = objectDate.getDate().toString().padStart(2, "0");
  const month = (objectDate.getMonth() + 1).toString().padStart(2, "0");
  const year = objectDate.getFullYear();
  return `${month}-${day}-${year}`;
};

export const dateFormat = newLocal_1;

// Get query parameters
export const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

// Simplified and safe regex validator
export const validateRegex = (field, regex, regex2) =>
  !!(regex?.test(field) || regex2?.test(field));

// Allowed MIME types
export const allowedTypes = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/jpg",
  "image/svg",
  "image/pdf",
];

export const allowedSizes = 5249980; // 5MB

export const allowedVideoTypes = [
  "video/mp4", "video/mov", "video/avi"
];

export const allowedVideoSizes = 52428800; // 50MB

// DNA Spinner component
export const LoaderSpinner = () => (
  <div className="d-flex justify-content-center align-items-center">
    <DNA
      visible={true}
      height="80"
      width="80"
      ariaLabel="dna-loading"
      wrapperStyle={{}}
      wrapperclassName="dna-wrapper"
    />
  </div>
);

// Text with tooltip on overflow
export const EllipsisWithTooltip = ({ text, maxWidth = "300px" }) => (
  <div
    className="text-truncate"
    title={text}
    style={{
      maxWidth,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      cursor: "pointer",
    }}
  >
    {text || "N/A"}
  </div>
);
